import { combineReducers, Reducer } from 'redux';
import { EditorState } from '../types';
import editor from './editor';
import extensionGif from './extension-gif';
import extensionEmote from './extension-emote';

// This type makes sure we do not forget to add a reducer for any slice
// of the store nor can we add extras for non-existing slices.
// Needed because monday (thursday) mornings exist.
type ReducersMapObject = {
  [k in keyof EditorState]: Reducer<any>;
};

const rootReducers: ReducersMapObject = {
  editor,
  extensionGif,
  extensionEmote,
};

export default combineReducers(rootReducers);
